
import { connect } from 'react-redux'
import PresenterScreenItem from './PresenterScreenItem'
import { State } from '../../../dataStore/reducers/reducerType'
import { PresenterScreenItemProps } from './types'

const mapStateToProps = (state: State, props: PresenterScreenItemProps ): PresenterScreenItemProps => ({
  presenter: props.presenter,
  mediaType: state.room.mediaType
})

export default connect(mapStateToProps)(PresenterScreenItem)
